const rawApiBaseUrl = process.env.REACT_APP_API_URL;

if (!rawApiBaseUrl) {
    throw new Error(
        "REACT_APP_API_URL nao foi definida. Configure a variavel no Cloudflare Pages."
    );
}

export const API_BASE_URL = rawApiBaseUrl.replace(/\/+$/, "");
const API_REQUEST_BASE_URL = process.env.NODE_ENV === "development" ? "" : API_BASE_URL;

export const CATEGORIAS_API_URL = `${API_REQUEST_BASE_URL}/api/v1/categorias`;
export const SOLICITACOES_API_URL = `${API_REQUEST_BASE_URL}/api/v1/solicitacoes`;
export const BAIRROS_API_URL = `${API_REQUEST_BASE_URL}/api/v1/enderecos/bairros`;
export const ATTACHMENTS_PRESIGN_API_URL = (requestId) =>
    `${SOLICITACOES_API_URL}/${encodeURIComponent(requestId)}/anexos/presign`;
export const REQUEST_ATTACHMENT_CONFIRM_API_URL = (requestId) =>
    `${SOLICITACOES_API_URL}/${encodeURIComponent(requestId)}/anexos/confirmacao`;
